import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import SideBar from "../../components/Sidebar";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../../../node_modules/bootstrap/dist/js/bootstrap.min.js";
import { GET_NEWS_BULLETIN_LIST } from "../../utils/constants";
import { makeAuthenticatedGet } from "../../utils/fetchUtils";
import BouncingDotsLoader from "../../components/LoadingDots";
import { fontSizeMap } from "../../utils/accessibilitySettings";
import { useFontSize } from "../../components/contexts/AccessibilityContext";
import useWindowWidth from "../../utils/windowWidth";
import NewsList from "./news";
import back from "../../assets/back.svg";

interface Article {
  title?: string;
  body?: string;
  source?: string;
  url?: string;
  imgUrl?:string;
}

function AccessNews() {
  const navigate = useNavigate();

  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();

  const { fontSize } = useFontSize();

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [news, setNews] = useState<Article>({});
  const [currPage, setCurrPage] = useState(0); // Track the current page (0 or 1) 0: news page | 1: article page
  const [language, setLanguage] = useState("english");

  const onPageChange = (newPage: any) => {
    if (newPage < 1 || newPage > totalPages) return; // Prevent going out of bounds
    setPage(newPage);
  };
  // const [displayStatus,setDisplayStatus] = useState<
  // "chatbot" | "news">("news");
  const [jobs, setJobs] = useState<any[]>([]);


  const fetchNewsList = async () => {
    try {
      // Build the base URL
      let url = `${GET_NEWS_BULLETIN_LIST}/${language}`;

      // Initialize an array to hold query parameters
      const queryParams: string[] = [`page=${page}`];

      // Append the query parameters to the URL if there are any
      if (queryParams.length > 0) {
        url += `?${queryParams.join("&")}`;
      }

      const response = await makeAuthenticatedGet(url);
      setJobs(response.list); 
      // setPage(response.page);
      setTotalPages(response.totalPages);
      // console.log("Fetched Articles:", response); 
    } catch (error) {
      console.error("Error fetching articles:", error);
    }
  };

  useEffect(() => {
    if (
      localStorage.getItem("token") === null ||
      localStorage.getItem("token") === undefined
    ) {
      navigate("/login");
    }
    fetchNewsList();
    document.title = "Accessible News - Nclude Portal";
  }, [page, language]);

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;
  // const currPage = 0;


  return (
    <div className="containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="News" />
        <div className="doc-container" role="main" tabIndex={-1}>
          {currPage === 0 && (
            <>
              <div>
                <h1
                  className="display-title"
                  ref={mainRef}
                  tabIndex={-1}
                >
                  Accessible News
                </h1>
              </div>
              {
                <section aria-labelledby="news-list-heading">
                  <h2 id="news-list-heading" className="visually-hidden">
                    News Bulletin List
                  </h2>
                  <div className="d-flex justify-content-end">
                    <select
                      className="form-select w-auto"
                      aria-label="Select language"
                      onChange={(e) => {
                        setLanguage(e.target.value);
                      }}
                      value={language}
                    >
                      <option value="english">English</option>
                    </select>
                  </div>
                  <div className="component-container">
                    {
                      <NewsList
                        jobs={jobs}
                        fetchNewsList={fetchNewsList}
                        page={page}
                        language={language}
                        setPage={setPage}
                        totalPages={totalPages}
                        onPageChange={onPageChange}
                      />
                    }
                  </div>
                </section>
              }
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default AccessNews;
